<template>
  <div>
    <v-container
      fluid
      :class="almost_mobile ? 'pt-16 stycard' : 'pt-16 px-10 stycard'"
      style="min-height: 100vh"
    >
      <h3 class="py-0 pl-2" style="color: #00a99d; font-size: 25px">
        ชำระเงิน
      </h3>
      <div style="margin-top: 30px"></div>
      <v-row class="my-2 mt-8">
        <v-col cols="12" md="4" sm="6" lg="4" align-self="center" class="pt-0">
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(2)"
            :class="paid == false ? 'theme-background' : 'light-theme'"
          >
            <v-row>
              <v-col cols="12" class="d-flex align-center justify-start pl-6">
                <v-img
                  :src="require('@/assets/icon/Telepharma/transport.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="paid == false ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      v-if="summaryQ !== null"
                      :class="paid == false ? 'text-ffffff' : 'text-00a99d'"
                      ><h3>{{ summaryQ.sum_wait }}</h3></span
                    >
                    <span
                      v-else
                      :class="paid == false ? 'text-ffffff' : 'text-00a99d'"
                      ><h3>0</h3></span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span :class="paid == false ? 'text-ffffff' : 'text-00a99d'"
                      >รอชำระเงิน</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="4"
          sm="6"
          lg="4"
          align-self="center"
          class="pr-0 pt-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(3)"
            :class="paid == true ? 'theme-background' : 'light-theme'"
          >
            <v-row>
              <v-col cols="12" class="d-flex align-center justify-start pl-6">
                <v-img
                  :src="require('@/assets/icon/Telepharma/success.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="paid == true ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      v-if="summaryQ !== null"
                      :class="paid == true ? 'text-ffffff' : 'text-00a99d'"
                      ><h3>{{ summaryQ.sum_paid }}</h3></span
                    >
                    <span
                      v-else
                      :class="paid == true ? 'text-ffffff' : 'text-00a99d'"
                      ><h3>0</h3></span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span :class="paid == true ? 'text-ffffff' : 'text-00a99d'"
                      >ชำระเงินเเล้ว</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mx-1 my-2 pt-1">
        <v-col cols="12" sm="12" md="4" lg="4" xl="3" class="card-search-start">
          <v-row>
            <v-col cols="12" class="px-2 pt-2 pb-3">
              <v-autocomplete
                class="card-small"
                no-filter
                v-model="itemsMember"
                return-object
                placeholder="ค้นหาชื่อหรือเบอร์โทร"
                :items="[...all_user, ...findUser]"
                solo
                hide-details
                dense
                @input="handleInput"
                @keyup="getPatients"
                item-text="one_id"
                color="#00a99d"
                item-color="teal darken-2"
                height="38"
                :readonly="isReadonly"
                clearable
                @click:clear="(search = ''), getPatients(), clearable()"
              >
                <template v-slot:append>
                  <v-btn text icon>
                    <v-icon color="#00A99D">mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
                  </v-list-item>
                </template>
                <template slot="selection" slot-scope="{ item }">
                  <span>{{ item.first_name_th }} {{ item.last_name_th }}</span>
                </template>
                <template slot="item" slot-scope="{ item }">
                  <div class="d-flex flex-column">
                    <span
                      >{{ item.first_name_th }} {{ item.last_name_th }}</span
                    >
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <!-- <v-col md="3" lg="2" cols="12" class="bg-ceefed">
          <v-row>
            <v-col cols="12" class="px-2 pt-2 pb-3">
              <v-autocomplete
                no-filter
                label="แพทย์ทั้งหมด"
                v-model="itemsDoctor"
                @input="getpayment"
                return-object
                :items="[...all_doctor, ...findDoctor]"
                @click="searchAllDoctor"
                @keyup="searchAllDoctor"
                item-text="one_id"
                :disabled="role_name == 'แพทย์'"
                solo
                dense
                hide-details
                height="38"
                class="card-small"
                color="#00a99d"
                item-color="teal darken-2"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
                  </v-list-item>
                </template>
                <template slot="selection" slot-scope="{ item }">
                  <span>{{ item.staff_first_name_th }}</span>
                </template>
                <template slot="item" slot-scope="{ item }">
                  <span>{{ item.staff_first_name_th }}</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-col> -->
        <v-col md="3" lg="2" cols="12" class="bg-ceefed pa-2">
          <!-- <v-row>
            <v-col cols="12" class="pa-2">
              <date-picker
                @change="changeDate"
                value-type="YYYY-MM-DD"
                v-model="filter.time"
                format="DD/MM/YYYY"
                class="card-small"
                dense
                placeholder="วัน-เดือน-ปี"
                color="#00a99d"
                :disabled-date="disableFutureDates"
              >
              </date-picker>
            </v-col>
          </v-row> -->
          <v-menu
            v-model="day_menu_payment"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            bottom
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                solo
                dense
                v-model="day_date_payment_text"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                hide-details
                class="card-small"
                color="#00a99d"
                v-on="on"
                clearable
                placeholder="วัน/เดือน/ปี"
                @click:clear="clearDate"
                height="38"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="day_date_payment"
              no-title
              scrollable
              locale="th"
              :max="maxDay"
              @input="changeDate()"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="3" lg="3" class="card-search-end">
          <v-row>
            <v-col cols="12" class="px-2 pt-2 pb-3">
              <v-autocomplete
                no-filter
                v-model="type_payment"
                placeholder="ทั้งหมด"
                solo
                dense
                hide-details
                :items="itemStatus"
                @input="getpayment"
                item-text="text"
                item-value="value"
                class="card-small"
                color="#00a99d"
                height="38"
                item-color="teal darken-2"
              >
                <!-- <template v-slot:append>
                  <v-btn text icon> </v-btn>
                </template> -->
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!--  ui ใหม่ -->
      <v-row class="ma-2 mt-8">
        <v-col cols="12" md="3" lg="3">
          <v-row class="card_pr">
            <v-col
              cols="12"
              class="elevation-1 table-viewdoc"
              style="min-height: 45vh; border-radius: 10px"
            >
              <v-row class="pa-1 ml-2">
                <v-col
                  cols="12"
                  class="py-5 font-20 w-700 text-09425A"
                  style="color: #00a99d"
                  v-if="paid == false"
                >
                  รอชำระเงิน
                </v-col>
                <v-col
                  v-else
                  cols="12"
                  class="py-5 font-20 w-700 text-09425A"
                  style="color: #00a99d"
                >
                  ชำระเงินเเล้ว
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="pa-0 ml-0 mr-0">
                <v-col
                  align="center"
                  cols="15"
                  class="font-20 w-700"
                  v-if="itemsQ.length !== 0"
                >
                  <v-list>
                    <v-list-item-group v-model="selectedItem" mandatory>
                      <v-list-item
                        v-for="(item, index) in itemsQ"
                        :key="index"
                        class="my-1"
                        style="border: 1px solid #e8e9e9; border-radius: 5px"
                        :value="index"
                        @click="slotTime(item)"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            <div class="d-flex flex-column">
                              <v-row>
                                <v-col cols="12" class="pb-0 text-left">
                                  <span class="w-500 font-16 mt-2 text-navy-50">
                                    {{ item.patient_name }}
                                  </span>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="6" class="text-left">
                                  <span class="w-500 font-14 mt-2 text-grey-70">
                                    <span
                                      :class="`w-500 font-14 mt-2 ${
                                        textstatus(item.type).color
                                      }`"
                                    >
                                      {{ textstatus(item.type).text }}
                                    </span>
                                  </span>
                                </v-col>
                                <!-- <v-col cols="6" class="pt-0 text-right">
                                  <span class="w-500 font-14 mt-2 text-grey-70">
                                    {{ item.appointment.start }} -
                                    {{ item.appointment.end }} น.
                                  </span>
                                </v-col> -->
                                <v-col cols="6" class="text-right">
                                  <span class="w-500 font-14 mt-2 text-grey-70">
                                    {{ Datetime(item.createdAt) }}
                                  </span>
                                </v-col>
                              </v-row>
                            </div>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                  <div
                    class="text-center"
                    style="font-size: 14px !important"
                    v-if="paymentTotal > 10"
                  >
                    <PaginationSmall
                      :totals="paymentTotal"
                      :isPage="page"
                      @page="changePage"
                    />
                  </div>
                </v-col>
                <v-col
                  align="center"
                  cols="12"
                  class="font-20 w-700"
                  style="margin-top: 117px"
                  v-else
                >
                  <span
                    class="w-700 text-navy-50 font-16"
                    style="color: #00a99d"
                    >ไม่มีรายการชำระเงิน</span
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="9"
          lg="9"
          class="elevation-1 table-viewdoc"
          style="min-height: 45vh; border-radius: 10px"
        >
          <div v-if="Detil.length !== 0 && itemsQ.length !== 0">
            <!-- type appointment  -->
            <v-row
              class="pr-0 pl-0"
              v-if="
                Detil.length !== 0 &&
                itemsQ.length !== 0 &&
                Detil.type == 'appointment'
              "
            >
              <v-col cols="12" class="px-0">
                <v-row class="mx-0">
                  <v-col cols="12" class="py-5">
                    <span class="w-700 text-navy-50 font-20"
                      >ข้อมูลการชำระเงิน</span
                    >
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-row class="my-3 mx-6">
                      <v-col cols="6">
                        <span class="text-left"> ออเดอร์เลขที่ </span>
                        <span class="w-700 text-1CA7B4">
                          {{ Detil.detail.order_id }}
                        </span>
                      </v-col>
                      <v-col
                        cols="6 "
                        class="text-right"
                        v-if="Detil.paid == true"
                      >
                        <div class="mb-2">
                          <span class="mr-1">ช่องทางการชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            Detil.payType
                          }}</span>
                        </div>
                        <div>
                          <span class="mr-1">วันที่ชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            showDate(Detil.paid_on)
                          }}</span
                          ><span class="mr-1"> เวลา</span>
                          <span class="w-700 text-1CA7B4"
                            >{{ showTime(Detil.paid_on) }} น.</span
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row
                  class="mx-6 mr-6"
                  style="border: 1px solid #e0edfa; border-radius: 10px"
                >
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                  >
                    <v-row class="ma-2">
                      <v-col md="1" lg="1" class="w-700 text-left">ลำดับ</v-col>
                      <v-col md="8" lg="8" class="w-700 text-left"
                        >รายการ</v-col
                      >
                      <v-col md="3" lg="3" class="w-700 text-right"
                        >ค่าบริการ</v-col
                      >
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                  >
                    <v-row class="ma-2">
                      <v-col md="1" lg="1" class="text-left">{{ 1 }}</v-col>
                      <v-col md="8" lg="8" class="text-left"
                        >{{ Detil.detail.order_desc }}
                        <v-row>
                          <span v-if="Detil.appointment" class="pt-1 ma-3">
                            เวลา {{ Detil.appointment.start }} -
                            {{ Detil.appointment.end }} น.</span
                          >
                          <span v-else class="pt-1 ma-3"> </span>
                        </v-row>
                      </v-col>
                      <v-col md="3" lg="3" class="text-right">{{
                        Detil.detail.total
                      }}</v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #eff6fc"
                  >
                    <v-row class="ma-2">
                      <v-col cols="12" class="text-right">
                        <div>
                          <span class="mx-4">ยอดรวม</span>
                          <span class="text-1CA7B4">{{
                            Detil.detail.total
                          }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- type excess  -->
            <v-row
              class="pr-0 pl-0"
              v-if="
                Detil.length !== 0 &&
                itemsQ.length !== 0 &&
                Detil.type == 'excess'
              "
              ><v-col
                cols="12"
                class="px-0"
                style="min-height: 45vh; border-radius: 10px"
              >
                <v-row class="mx-0">
                  <v-col cols="12" class="py-5">
                    <span class="w-700 text-navy-50 font-20"
                      >ข้อมูลการชำระเงิน</span
                    >
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-row class="my-3 mx-6">
                      <v-col cols="6">
                        <span class="text-left"> ออเดอร์เลขที่ </span>
                        <span class="w-700 text-1CA7B4">
                          {{ Detil.detail.order_id }}
                        </span>
                      </v-col>
                      <v-col
                        cols="6 "
                        class="text-right"
                        v-if="Detil.paid == true"
                      >
                        <div class="mb-2">
                          <span class="mr-1">ช่องทางการชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            Detil.payType
                          }}</span>
                        </div>
                        <div>
                          <span class="mr-1">วันที่ชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            showDate(Detil.paid_on)
                          }}</span
                          ><span class="mr-1"> เวลา</span>
                          <span class="w-700 text-1CA7B4"
                            >{{ showTime(Detil.paid_on) }} น.</span
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row
                  class="mx-6 mr-6"
                  style="border: 1px solid #e0edfa; border-radius: 10px"
                >
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                  >
                    <v-row class="ma-2">
                      <v-col
                        cols="12"
                        class="pa-0"
                        style="border-bottom: 1px solid #e0edfa"
                      >
                        <v-row class="ma-2 w-700">
                          <v-col md="1" lg="1" class="text-left">ลำดับ</v-col>
                          <v-col md="8" lg="8" class="text-left">รายการ</v-col>
                          <v-col md="3" lg="3" class="text-right"
                            >ค่าบริการ</v-col
                          >
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        class="pa-0"
                        style="border-bottom: 1px solid #e0edfa"
                      >
                        <v-row class="ma-2">
                          <v-col md="1" lg="1" class="text-left">{{ 1 }}</v-col>
                          <v-col md="8" lg="8" class="text-left"
                            >{{ Detil.detail.order_desc }}
                            <v-row>
                              <span v-if="Detil.appointment" class="pt-1 ma-3">
                                เวลา {{ Detil.appointment.start }} -
                                {{ Detil.appointment.end }} น.</span
                              >
                              <span v-else class="pt-1 ma-3"> </span>
                            </v-row>
                          </v-col>
                          <v-col md="3" lg="3" class="text-right">{{
                            Detil.detail.total
                          }}</v-col>
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        class="pa-0"
                        style="border-bottom: 1px solid #eff6fc"
                      >
                        <v-row class="ma-2">
                          <v-col cols="12" class="text-right">
                            <div>
                              <span class="mx-4">ยอดรวม</span>
                              <span class="text-1CA7B4">{{
                                Detil.detail.total
                              }}</span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- type drug  -->
            <v-row
              class="pr-0 pl-0"
              v-else-if="
                (check_biz !== '668236676897760' &&
                  Detil.length !== 0 &&
                  itemsQ.length !== 0 &&
                  Detil.type == 'drug') ||
                Detil.type == 'drug-webtoweb'
              "
            >
              <v-col cols="12" class="px-0">
                <v-row class="mx-0">
                  <v-col cols="12" class="py-5">
                    <span class="w-700 text-navy-50 font-20"
                      >ข้อมูลการชำระเงิน</span
                    >
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-row class="my-3 mx-6">
                      <v-col cols="6">
                        <span class="text-left"> ออเดอร์เลขที่ </span>
                        <span class="w-700 text-1CA7B4">
                          {{ Detil.detail.order_id }}
                        </span>
                      </v-col>
                      <v-col
                        cols="6 "
                        class="text-right"
                        v-if="Detil.paid == true"
                      >
                        <div class="mb-2">
                          <span class="mr-1">ช่องทางการชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            Detil.payType
                          }}</span>
                        </div>
                        <div>
                          <span class="mr-1">วันที่ชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            showDate(Detil.paid_on)
                          }}</span
                          ><span class="mr-1"> เวลา</span>
                          <span class="w-700 text-1CA7B4"
                            >{{ showTime(Detil.paid_on) }} น.</span
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row
                  class="mx-6 mr-6"
                  style="border: 1px solid #e0edfa; border-radius: 10px"
                >
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                  >
                    <v-row class="ma-2 w-700">
                      <v-col md="1" lg="1" class="text-left">ลำดับ</v-col>
                      <v-col md="5" lg="5" class="text-left">รายการ</v-col>
                      <v-col md="2" lg="2" class="text-right">หน่วย</v-col>
                      <v-col md="2" lg="2" class="text-right">ราคา</v-col>
                      <v-col md="2" lg="2" class="text-right">ราคารวม</v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                    >
                    <v-row
                      class="ma-2"
                      v-for="(Detil, index) in Detil.diagnostichistories
                        .drug_list"
                      :key="index"
                    >
                      <v-col md="1" lg="1" class="text-left">{{
                        index + 1
                      }}</v-col>
                      <v-col md="5" lg="5" class="text-left"
                        >{{ Detil.name_drug }}
                      </v-col>
                      <v-col md="2" lg="2" class="text-right">{{
                        Detil.count
                      }}</v-col>
                      <v-col md="2" lg="2" class="text-right">{{
                        Detil.price
                      }}</v-col>
                      <v-col md="2" lg="2" class="text-right">{{
                        Detil.price * Detil.count
                      }}</v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #eff6fc"
                  >
                    <v-row class="ma-2">
                      <v-col cols="12" class="text-right">
                        <div>
                          <span class="mx-4">ยอดรวม</span>
                          <span class="text-1CA7B4">{{ sumPrice(Detil) }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- type excessanddrug  -->
            <v-row
              class="pr-0 pl-0"
              v-else-if="
                Detil.length !== 0 &&
                itemsQ.length !== 0 &&
                Detil.type == 'excessanddrug'
              "
            >
              <v-col cols="12" class="px-0">
                <v-row class="mx-0">
                  <v-col cols="12" class="py-5">
                    <span class="w-700 text-navy-50 font-20"
                      >ข้อมูลการชำระเงิน</span
                    >
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-row class="my-3 mx-6">
                      <v-col cols="6">
                        <span class="text-left"> ออเดอร์เลขที่ </span>
                        <span class="w-700 text-1CA7B4">
                          {{ Detil.detail.order_id }}
                        </span>
                      </v-col>
                      <v-col
                        cols="6 "
                        class="text-right"
                        v-if="Detil.paid == true"
                      >
                        <div class="mb-2">
                          <span class="mr-1">ช่องทางการชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            Detil.payType
                          }}</span>
                        </div>
                        <div>
                          <span class="mr-1">วันที่ชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            showDate(Detil.paid_on)
                          }}</span
                          ><span class="mr-1"> เวลา</span>
                          <span class="w-700 text-1CA7B4"
                            >{{ showTime(Detil.paid_on) }} น.</span
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row
                  class="mx-6 mr-6"
                  style="border: 1px solid #e0edfa; border-radius: 10px"
                >
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                  >
                    <v-row class="ma-2 w-700">
                      <v-col md="1" lg="1" class="text-left">ลำดับ</v-col>
                      <v-col md="5" lg="5" class="text-left">รายการ</v-col>
                      <v-col md="2" lg="2" class="text-right">หน่วย</v-col>
                      <v-col md="2" lg="2" class="text-right">ราคา</v-col>
                      <v-col md="2" lg="2" class="text-right">ราคารวม</v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                  >
                    <v-row
                      class="ma-2"
                      v-for="(Detil, index) in Detil.detail.drug_list"
                      :key="index"
                    >
                      <v-col md="1" lg="1" class="text-left">{{
                        index + 1
                      }}</v-col>
                      <v-col md="5" lg="5" class="text-left"
                        >{{ Detil.name_drug }}
                      </v-col>
                      <v-col md="2" lg="2" class="text-right">{{
                        Detil.quantity
                      }}</v-col>
                      <v-col md="2" lg="2" class="text-right">{{
                        Detil.price
                      }}</v-col>
                      <v-col md="2" lg="2" class="text-right">{{
                        Detil.price * Detil.quantity
                      }}</v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #eff6fc"
                  >
                    <v-row class="ma-2">
                      <v-col cols="12" class="text-right">
                        <div>
                          <span class="mx-4">ยอดรวม</span>
                          <span class="text-1CA7B4">{{
                            sumExcessanddrug(Detil)
                          }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- type drug kasemrat  -->
            <v-row
              class="pr-0 pl-0"
              v-else-if="
                check_biz == '668236676897760' &&
                Detil.length !== 0 &&
                itemsQ.length !== 0 &&
                Detil.type == 'drug'
              "
            >
              <v-col cols="12" class="px-0">
                <v-row class="mx-0">
                  <v-col cols="12" class="py-5">
                    <span class="w-700 text-navy-50 font-20"
                      >ข้อมูลการชำระเงิน</span
                    >
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-row class="my-3 mx-6">
                      <v-col cols="6">
                        <span class="text-left"> ออเดอร์เลขที่ </span>
                        <span class="w-700 text-1CA7B4">
                          {{ Detil.detail.order_id }}
                        </span>
                      </v-col>
                      <v-col
                        cols="6 "
                        class="text-right"
                        v-if="Detil.paid == true"
                      >
                        <div class="mb-2">
                          <span class="mr-1">ช่องทางการชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            Detil.payType
                          }}</span>
                        </div>
                        <div>
                          <span class="mr-1">วันที่ชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            showDate(Detil.paid_on)
                          }}</span
                          ><span class="mr-1"> เวลา</span>
                          <span class="w-700 text-1CA7B4"
                            >{{ showTime(Detil.paid_on) }} น.</span
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row
                  class="mx-6 mr-6"
                  style="border: 1px solid #e0edfa; border-radius: 10px"
                >
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                  >
                    <v-row class="ma-2 w-700">
                      <v-col md="1" lg="1" class="text-left">ลำดับ</v-col>
                      <v-col md="5" lg="5" class="text-left">รายการ</v-col>
                      <v-col md="2" lg="2" class="text-right">หน่วย</v-col>
                      <v-col md="2" lg="2" class="text-right">ราคา</v-col>
                      <v-col md="2" lg="2" class="text-right">ราคารวม</v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                  >
                    <v-row
                      class="ma-2"
                      v-for="(Detil, index) in Detil.detail.drug_list"
                      :key="index"
                    >
                      <v-col md="1" lg="1" class="text-left">{{
                        index + 1
                      }}</v-col>
                      <v-col md="5" lg="5" class="text-left"
                        >{{ Detil.name_drug }}
                      </v-col>
                      <v-col md="2" lg="2" class="text-right">{{
                        Detil.quantity
                      }}</v-col>
                      <v-col md="2" lg="2" class="text-right">{{
                        Detil.price
                      }}</v-col>
                      <v-col md="2" lg="2" class="text-right">{{
                        Detil.price * Detil.total
                      }}</v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #eff6fc"
                  >
                    <v-row class="ma-2">
                      <v-col cols="12" class="text-right">
                        <div>
                          <span class="mx-4">ยอดรวม</span>
                          <span class="text-1CA7B4">{{
                            sumExcessanddrug(Detil)
                          }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- type prescription -->
            <v-row
              class="pr-0 pl-0"
              v-else-if="
                Detil.length !== 0 &&
                itemsQ.length !== 0 &&
                Detil.type == 'prescription'
              "
            >
              <v-col
                cols="12"
                class="bg-white pl-0 pr-0"
                style="min-height: 45vh; border-radius: 10px"
              >
                <v-row class="mx-0">
                  <v-col cols="12" class="py-5">
                    <span class="w-700 text-navy-50 font-20"
                      >ข้อมูลการชำระเงิน</span
                    >
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-row class="my-3 mx-6">
                      <v-col cols="6">
                        <span class="text-left"> ออเดอร์เลขที่ </span>
                        <span class="w-700 text-1CA7B4">
                          {{ Detil.detail.order_id }}
                        </span>
                      </v-col>
                      <v-col
                        cols="6 "
                        class="text-right"
                        v-if="Detil.paid == true"
                      >
                        <div class="mb-2">
                          <span class="mr-1">ช่องทางการชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            Detil.payType
                          }}</span>
                        </div>
                        <div>
                          <span class="mr-1">วันที่ชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            showDate(Detil.paid_on)
                          }}</span
                          ><span class="mr-1"> เวลา</span>
                          <span class="w-700 text-1CA7B4"
                            >{{ showTime(Detil.paid_on) }} น.</span
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row
                  class="mx-6 mr-6"
                  style="border: 1px solid #e0edfa; border-radius: 10px"
                >
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                  >
                    <v-row class="ma-2 w-700">
                      <v-col md="1" lg="1" class="text-left">ลำดับ</v-col>
                      <v-col md="5" lg="5" class="text-left">รายการ</v-col>
                      <v-col md="2" lg="2" class="text-right">หน่วย</v-col>
                      <v-col md="2" lg="2" class="text-right">ราคา</v-col>
                      <v-col md="2" lg="2" class="text-right">ราคารวม</v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                  >
                    <v-row
                      class="ma-2"
                      v-for="(Detil, index) in Detil.prescription.drug_list"
                      :key="index"
                    >
                      <v-col md="1" lg="1" class="text-left">{{
                        index + 1
                      }}</v-col>
                      <v-col md="5" lg="5" class="text-left"
                        >{{ Detil.name_drug }}
                      </v-col>
                      <v-col md="2" lg="2" class="text-right">{{
                        Detil.count
                      }}</v-col>
                      <v-col md="2" lg="2" class="text-right">{{
                        Detil.price
                      }}</v-col>
                      <v-col md="2" lg="2" class="text-right">{{
                        Detil.total
                      }}</v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #eff6fc"
                  >
                    <v-row class="ma-2">
                      <v-col cols="12" class="text-right">
                        <div>
                          <span class="mx-4">ยอดรวม</span>
                          <span class="text-1CA7B4">{{
                            sumPricePrescription(Detil)
                          }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- type Physicalexam -->
            <v-row
              class="pr-0 pl-0"
              v-else-if="
                Detil.length !== 0 &&
                itemsQ.length !== 0 &&
                Detil.type == 'Physicalexam'
              "
            >
              <v-col
                cols="12"
                class="bg-white pl-0 pr-0"
                style="min-height: 45vh; border-radius: 10px"
              >
                <v-row class="mx-0">
                  <v-col cols="12" class="py-5">
                    <span class="w-700 text-navy-50 font-20"
                      >ข้อมูลการชำระเงิน</span
                    >
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-row class="my-3 mx-6">
                      <v-col cols="6">
                        <span class="text-left"> ออเดอร์เลขที่ </span>
                        <span class="w-700 text-1CA7B4">
                          {{ Detil.detail.order_id }}
                        </span>
                      </v-col>
                      <v-col
                        cols="6 "
                        class="text-right"
                        v-if="Detil.paid == true"
                      >
                        <div class="mb-2">
                          <span class="mr-1">ช่องทางการชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            Detil.payType
                          }}</span>
                        </div>
                        <div>
                          <span class="mr-1">วันที่ชำระเงิน</span>
                          <span class="w-700 text-1CA7B4">{{
                            showDate(Detil.paid_on)
                          }}</span
                          ><span class="mr-1"> เวลา</span>
                          <span class="w-700 text-1CA7B4"
                            >{{ showTime(Detil.paid_on) }} น.</span
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row
                  class="mx-6 mr-6"
                  style="border: 1px solid #e0edfa; border-radius: 10px"
                >
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                  >
                    <v-row class="ma-2 w-700">
                      <v-col md="1" lg="1" class="text-left">ลำดับ</v-col>
                      <v-col md="8" lg="8" class="text-left">รายการ</v-col>
                      <v-col md="3" lg="3" class="text-right">ค่าบริการ</v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #e0edfa"
                  >
                    <v-row class="ma-2">
                      <v-col md="1" lg="1" class="text-left">{{ 1 }}</v-col>
                      <v-col md="8" lg="8" class="text-left"
                        >{{ Detil.detail.order_desc }}
                        <!-- <v-row>
                        <span class="pt-1 ma-3">
                          เวลา {{ Detil.appointment.start }} -
                          {{ Detil.appointment.end }} น.</span
                        >
                      </v-row> -->
                      </v-col>
                      <v-col md="3" lg="3" class="text-right">{{
                        Detil.detail.total
                      }}</v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pa-0"
                    style="border-bottom: 1px solid #eff6fc"
                  >
                    <v-row class="ma-2">
                      <v-col cols="12" class="text-right">
                        <div>
                          <span class="mx-4">ยอดรวม</span>
                          <span class="text-1CA7B4">{{
                            Detil.detail.total
                          }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <v-col class="pa-1 text-center" style="margin-top: 150px">
              <span class="w-700 text-navy-50 font-32" style="color: #00a99d"
                >ไม่มีรายการชำระเงิน</span
              >
            </v-col>
          </div>
        </v-col>
      </v-row>

      <!----พบแพทย์------------->
      <DeleteAppointment :dataOn="textDialog" />
      <!-- <PersonalPatientDialog ref="personalPatientDialog" @close="getpayment" /> -->
      <!-- <ModalVaccine /> -->
      <ModalSuccess />
      <v-dialog v-model="dialogCon" persistent width="300">
        <v-card color="#00a99d" dark>
          <v-card-text>
            <div style="text-align: center">กำลังเชื่อมต่อข้อมูล</div>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- snackbar -->
      <v-snackbar
        v-model="snackbar"
        top
        right
        timeout="2000"
        :color="snackbarColor"
      >
        <span class="text-navy-50">{{ snackbarText }}</span>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
// import functioncryto from "@/services/encrypt.js";
// import config from "@/views/json_temp/appointment.json";
// import data from '@/data/temp_appointment.json'
import { PaginationSmall } from "@/components/pagination/";
// import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue2-datepicker/locale/th";
// import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import { DeleteAppointment, ModalSuccess } from "@/components/modal/index.js";
// import PersonalPatientDialog from "@/components/dialog/personalPatientDialog.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import { EventBus } from "../../EventBus";

export default {
  components: {
    // DatePicker,
    // VueTimepicker,
    DeleteAppointment,
    // PersonalPatientDialog,
    ModalSuccess,
    PaginationSmall,
    // HistoryTalking,
    // MedicalHistory,
    // HistoryTalkingMain,
    // MedicalHistoryMain
    // Pagination,
  },
  data() {
    return {
      isReadonly: false,
      paid: false,
      status: 1,
      itemsQ: [],
      day_menu_payment: false,
      day_date_payment_text: "",
      day_date_payment: "",
      maxDay: moment().format("YYYY-MM-DD"),
      maxDate: new Date().toISOString().split("T")[0],
      dialogCon: false,
      itemsDoctor: null,
      itemsMember: null,
      summaryQ: { sum_paid: 0, sum_wait: 0 },
      snackbar: false,
      snackbarText: "",
      snackbarColor: "#FFC259",
      itemAppointment: [],
      editParamAppointment: {},
      itemTab: [
        // "HistoryTalking",
        // "MedicalHistory",
        "HistoryTalkingMain",
        "MedicalHistoryMain",
      ],

      filter: {
        key: "",
        status: "",
        member: "",
        doctorId: "",
        time: moment(new Date()).format("YYYY-MM-DD"),
      },
      paramAppointment: {
        memberId: "",
        doctorId: "",
        // clinicId: this.$cookies.get('me').clinicId,
        time: moment(new Date()).format("YYYY-MM-DD"),
        startTime: "",
        endTime: "",
        service: "",
        reason: "",
        prepare: "",
      },
      page: 1,
      type_payment: "",
      itemStatus: [
        { value: "", text: "ทั้งหมด" },
        { value: "appointment", text: "นัดหมาย" },
        { value: "drug", text: "สั่งยา" },
        { value: "Physicalexam", text: "ตรวจร่างกาย" },
        { value: "excess", text: "ค่าส่วนเกิน" },
        { value: "excessanddrug", text: "ค่าส่วนเกินเเละค่ายา" },
      ],
      // config,
      text: "",
      all_user: [{ _id: "all", first_name_th: "ผู้ป่วยทั้งหมด", one_id: "" }],
      all_doctor: [
        { _id: "all", staff_first_name_th: "แพทย์ทั้งหมด", one_id: "" },
      ],
      addAppointmentDialog: false,
      editAppointmentDialog: false,
      addAppointment: false,
      cancelAppointment: false,

      changeStatusAppointment: false,

      findMember: [],
      findDoctor: [],
      statusPut: "",
      idPut: "",
      findUser: [],
      seeingDocData: { conference: "" },
      itemSeeingDoc: { tempData: "" },
      textDialog: { title: "", text: "", type: "" },
      countData: 0,
      countData1: 0,
      countData2: 0,
      total: 0,
      searchKey: "",
      searchDoc: "",
      doc_name: "",
      currentDentist: [],
      role_name: sessionStorage.role_name,
      check_biz: sessionStorage.biz_id,
      acc_id: sessionStorage.account_id,
      patient_id: "",

      den_id: "",
      numStatus: 0,
      paymentTotal: 0,

      //  new
      tab: "",
      selectedItem: 0,
      patientDetil: [],
      Detil: [],
      reset: false,
      tabPage: "",
    };
  },
  created() {
    var year1 = "";
    var year2 = "";
    this.day_date_payment = moment().format("YYYY-MM-DD");
    year1 = moment(this.day_date_payment).locale("th").format("YYYY");
    year2 = (parseInt(year1) + 543).toString();
    this.day_date_payment_text = moment(this.day_date_payment)
      .locale("th")
      .format("DD/MM/" + year2);
  },
  async mounted() {
    this.disableFutureDates();
    this.itemsMember = {
      _id: "all",
      first_name_th: "ผู้ป่วยทั้งหมด",
      one_id: "",
    };
    var from = this.$route.query["from"] || "";
    if (from == "redirectDhealth") {
      this.from_redirect = true;
    }
    if (this.role_name == "แพทย์") {
      // this.itemsDoctor = this.acc_id;
      this.itemsDoctor = { one_id: this.acc_id };
    }
    // this.getDoc();
    EventBus.$on("searchNotification", () => {
      this.getPatients();
      this.searchAllDoctor();
    });
    this.getPatients();
    this.searchAllDoctor();
    if (this.$route.query["from"] == "redirect") {
      // this.tab = "HistoryTalkingMain";
      // this.status = "2"
      // this.page = 1
      this.activeGet(2);
      // this.getqueue();
    } else {
      this.getpayment();
    }
    // this.getDrugList();
    await this.getpayment();
    // await this.summaryQ();
  },
  computed: {
    ...mapGetters(["bizId"]),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters({
      permiss: "permissionsGetter" || {},
      items: "setPatientIdGetter" || "",
    }),
    isBreakpoint() {
      return this.$vuetify.breakpoint.name;
    },
  },
  watch: {
    searchKey(v) {
      // console.log(v)
      v !== null
        ? (this.patient_id = v.oneid)
        : v === null
        ? this.getAppointment()
        : (this.patient_id = "");
      this.searchMember(v.first_name_th);
    },
    searchDoc(v) {
      // console.log(v)
      v !== null
        ? (this.den_id = v.dentist_id)
        : v === null
        ? this.getAppointment()
        : (this.den_id = "");
      this.searchDoctor(v.dentist_name);
    },
  },
  beforeDestroy() {
    EventBus.$off("searchNotification");
  },
  methods: {
    handleInput(value) {
      this.itemsMember = value;
      if (value) {
        this.isReadonly = true;
        this.getpayment();
      }
    },
    clearable() {
      this.isReadonly = false;
    },
    disableFutureDates(date) {
      const today = new Date();
      return date > today;
    },
    logg(item) {
      console.log("logg", item);
    },
    showHeader(size = "lg") {
      if (size === "md") return true;
      if (size === "lg") return true;
      if (size === "xl") return true;
      return false;
    },
    // configHeader(confer) {
    //   // console.log(confer);
    //   if (confer) return this.config["header-product"];
    //   return this.config["header-product-no-con"];
    // },
    displayMenu1(text, display, func) {
      if (text.length === 0) return 0;
      const { permission = {} } = text;
      if (permission.length !== undefined) {
        const { "menu-1": { show, option, sub } = {} } = permission[0];
        if (display === "display") {
          return !show;
        } else if (display === "sub") {
          return sub[func];
        } else {
          if (show) {
            return option;
          }
        }
      } else {
        const { "menu-1": { show, option, sub } = {} } = permission;
        if (display === "display") {
          return !show;
        } else if (display === "sub") {
          return sub[func];
        } else {
          if (show) {
            return option;
          }
        }
      }

      return "";
    },
    async getpayment() {
      try {
        this.dialogCon = true;
        this.itemsQ = [];
        let keyPat = this.itemsMember;
        var doctorKey = "";
        if (keyPat === null || keyPat === undefined) {
          keyPat = "";
        } else keyPat = this.itemsMember.one_id;

        if (this.itemsDoctor === undefined || this.itemsDoctor === null) {
          doctorKey = "";
        } else {
          doctorKey = this.itemsDoctor.one_id;
        }
        const params = new URLSearchParams();
        params.append("biz_id", sessionStorage.biz_id);
        params.append("patient_id", keyPat);
        params.append("dentist_id", doctorKey);
        params.append("date", this.day_date_payment || "");
        params.append("limit", 10);
        params.append("page", this.page);
        params.append("paid", this.paid);
        params.append("type", this.type_payment);
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/payment?${params}`)
          .then((res) => {
            this.itemsQ = res.data.data.payment[0].data;
            if (this.itemsQ.length !== 0 && "_id" in this.itemsQ[0]) {
              this.selectedItem = res.data.data.payment[0].data[0]._id;
              this.slotTime(this.itemsQ[0]);
            } else {
              this.selectedItem = "";
              this.Detil = "";
            }
            this.summaryQ = res.data.data;
            let total_payment = res.data.data.payment[0].metadata;
            if (total_payment.length > 0) {
              this.paymentTotal = total_payment[0].total || 0;
            }
            this.dialogCon = false;
          });
      } catch (error) {
        console.error();
      }
    },
    sumPrice(Detil) {
      let netprice = 0;
      Detil.diagnostichistories.drug_list.forEach((ele) => {
        if (ele.price !== "" && ele.drug_list !== "") {
          netprice += Number(ele.price) * Number(ele.count);
        }
      });
      return netprice.toFixed(2);
    },
    sumExcessanddrug(Detil) {
      let netprice = 0;
      if (Detil.biz_id == "668236676897760") {
        console.log("🚀 ~ sumExcessanddrug ~ Detil:", Detil);
        netprice = Detil.detail.total;
      } else {
        Detil.detail.drug_list.forEach((ele) => {
          if (ele.price !== "" && ele.drug_list !== "") {
            netprice += Number(ele.price) * Number(ele.total);
          }
        });
      }
      return netprice.toFixed(2);
    },
    sumPricePrescription(Detil) {
      let netprice = 0;
      Detil.prescription.drug_list.forEach((ele) => {
        if (ele.price !== "" && ele.drug_list !== "") {
          netprice += Number(ele.price) * Number(ele.count);
        }
      });
      return netprice.toFixed(2);
    },
    changeDate() {
      var year1 = "";
      var year2 = "";
      year1 = moment(this.day_date_payment).locale("th").format("YYYY");
      year2 = (parseInt(year1) + 543).toString();
      this.day_date_payment_text = moment(this.day_date_payment)
        .locale("th")
        .format("DD/MM/" + year2);
      this.day_menu_payment = false;
      this.page = 1;
      this.getpayment();
    },
    clearDate() {
      this.day_date_payment = "";
      this.page = 1;
      this.getpayment();
    },
    successCon() {
      this.status = 3;
      this.getpayment();
    },
    async getDoc() {
      try {
        const res = await this.axios.get(
          process.env.VUE_APP_BASE_URL +
            `/get-info-doctors?dentist_clinic_id=${sessionStorage.dentist_clinic_id}`
        );
        await this.$store.dispatch("actionLog", {
          action: "get Doc",
          action_by: sessionStorage.account_id,
          path: `/get-info-doctors`,
          params: {
            dentist_clinic_id: sessionStorage.dentist_clinic_id,
          },
        });
        this.doctors = res.data.result;
        this.displayMenu1(this.permiss, "sub", "func-1-1").option;
        if (
          this.displayMenu1(this.permiss, "sub", "func-1-1").option ==
            "person" ||
          this.displayMenu1(this.permiss, "sub", "func-1-1").option === "all"
        ) {
          var dentist = this.doctors.find(
            (item) => item.dentist_id == sessionStorage.account_id
          );
          if (dentist) {
            this.currentDentist = {
              dentist_name: dentist.dentist_name,
              dentist_id: dentist.dentist_id,
            };
            this.doc_name = this.currentDentist.dentist_name;
            // this.data.selectedStaffData = this.currentDentist
            // this.data.selecteDentist = this.currentDentist
            // this.dataSlot.selectedStaffData = this.currentDentist
          }
          // console.log("this.currentDentist", this.currentDentist);
        }
      } catch (e) {
        console.log("error");
      }
    },
    changePage(page) {
      this.page = page;
      this.getpayment();
    },
    getPatients(text) {
      // this.findUser =  []
      // let data_user = [];
       let limit = 1000
      let word = "";
      if (text === undefined) {
        word = "";
      } else word = text.target.value;
      this.axios
        .get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/patients/search?biz_id=${sessionStorage.biz_id}&search=${word}&limit=${limit}`
        )
        .then((res) => {
          this.findUser = res.data.data[0].data;
          // data_user = res.data.data[0].data;
          // this.findUser = data_user.filter(
          //   (item) => item.one_id !== null && item.one_id !== undefined
          // );
        });
    },
    searchMember(text) {
      let Today = this.$moment().format("YYYY-MM-DD");
      this.itemAppointment = [];
      this.countData = 0;
      this.countData1 = 0;
      this.countData2 = 0;
      this.total = 0;
      this.axios
        .post(
          `${process.env.VUE_APP_BASE_URL}/get-patient`,
          {
            keyword: `${text}`,
            dentist_clinic_id: sessionStorage.dentist_clinic_id,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.one_access_token}`,
            },
          }
        )
        .then(async (res) => {
          let id = res.data.message.result;
          this.axios
            .get(
              `${process.env.VUE_APP_BASE_URL}/queue?dentist_id=${this.currentDentist.dentist_id}&patient_id=${id[0].oneid}&start_time=${Today}`,
              {
                headers: {
                  Authorization:
                    "Bearer " + sessionStorage.getItem("one_access_token"),
                  role: encodeURIComponent(sessionStorage.role_name),
                  dentist_clinic_id: decodeURIComponent(
                    sessionStorage.dentist_clinic_id
                  ),
                },
              }
            )
            .then(async (res) => {
              if (res.data.message === "success") {
                this.itemAppointment = res.data.data;
                res.data.data.forEach((element) => {
                  if (element.stage == 1) this.countData += 1;
                  if (element.stage == 2) this.countData1 += 1;
                  if (element.stage == 3) this.countData2 += 1;
                  if (element.stage) this.total += 1;
                });
              }
            });
        });
    },
    searchAllDoctor(text) {
      let word = "";
      if (text === undefined) {
        word = "";
      } else word = text.target.value;
      this.axios
        .get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/staffs/${sessionStorage.biz_id}?search=${word}&role=${sessionStorage.role_name}&limit=100`
        )
        .then(async (res) => {
          this.findDoctor = res.data.data[0].data;
        });
    },
    searchDoctor(key) {
      let Today = this.$moment().format("YYYY-MM-DD");
      this.itemAppointment = [];
      this.countData = 0;
      this.countData1 = 0;
      this.countData2 = 0;
      this.total = 0;

      this.axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/search-doctor?keyword=${key}&dentist_clinic_id=${sessionStorage.dentist_clinic_id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.one_access_token}`,
            },
          }
        )
        .then(async (res) => {
          await this.$store.dispatch("actionLog", {
            action: "search Doctor",
            action_by: sessionStorage.account_id,
            path: `/search-doctor`,
            params: {
              keyword: key,
              dentist_clinic_id: sessionStorage.dentist_clinic_id,
            },
            header: {
              Authorization: `Bearer ${sessionStorage.one_access_token}`,
            },
          });
          let dentist = res.data.result;
          this.axios
            .get(
              `${process.env.VUE_APP_BASE_URL}/queue?dentist_id=${
                dentist[0].dentist_id || ""
              }&start_time=${Today}`,
              {
                headers: {
                  Authorization:
                    "Bearer " + sessionStorage.getItem("one_access_token"),
                  role: encodeURIComponent(sessionStorage.role_name),
                  dentist_clinic_id: decodeURIComponent(
                    sessionStorage.dentist_clinic_id
                  ),
                },
              }
            )
            .then(async (res) => {
              await this.$store.dispatch("actionLog", {
                action: "search Doctor",
                action_by: sessionStorage.account_id,
                path: `/queue`,
                params: {
                  dentist_id: dentist[0].dentist_id || "",
                  start_time: Today,
                },
                header: {
                  Authorization: `Bearer ${sessionStorage.one_access_token}`,
                },
              });
              if (res.data.message === "success") {
                this.itemAppointment = res.data.data;
                res.data.data.forEach((element) => {
                  if (element.stage == 1) this.countData += 1;
                  if (element.stage == 2) this.countData1 += 1;
                  if (element.stage == 3) this.countData2 += 1;
                  if (element.stage) this.total += 1;
                });
              }
            });
        });
    },
    resetData() {
      this.addAppointmentDialog = false;
      Object.keys(this.paramAppointment).forEach((element) => {
        if (element === "clinicId") {
          this.paramAppointment[element] = this.$cookies.get("me").clinicId;
        } else if (element === "time") {
          this.paramAppointment[element] = this.$moment().format("YYYY-MM-DD");
        } else this.paramAppointment[element] = "";
      });
    },
    activeGet(e) {
      this.page = 1;
      if (e === 1) {
        this.paid = "";
        this.getpayment();
        // this.filter_status(0)
      }

      if (e === 2) {
        this.paid = false;
        this.getpayment();
        // this.filter_status(-1)
      }
      if (e === 3) {
        this.paid = true;
        this.getpayment();
        // this.filter_status(1)
      }
      if (e === 4) {
        this.status = 3;
        this.getpayment();
        // this.filter_status(3)
      }
    },
    textstatus(type) {
      if (type == "appointment") {
        return { text: "นัดหมาย", color: "text-FFA07A" };
      }
      if (type == "drug") {
        return { text: "สั่งยา(เเพทย์)", color: "text-336AB4" };
      }
      if (type == "prescription") {
        return { text: "สั่งยา(พยาบาล)", color: "text-336AB4" };
      }
      if (type == "drug-webtoweb") {
        return { text: "สั่งยา(เเพทย์)", color: "text-336AB4" };
      }
      if (type == "Physicalexam") {
        return { text: "ตรวจสุขภาพ", color: "text-F9C74F" };
      }
      if (type == "excess") {
        return { text: "ค่าส่วนเกิน", color: "text-FFA07A" };
      }
      if (type == "excessanddrug") {
        return { text: "ค่าส่วนเกินเเละค่ายา", color: "text-FFA07A" };
      }
    },
    slotTime(item) {
      this.Detil = item;
      this.reset = !this.reset;
    },
    changeComponent(page) {
      console.log("changeComponent", page);
      this.tabPage = page;
    },
    showTime(item) {
      return moment(item).locale("TH").format("LT");
    },
    showDate(item) {
      var year1 = moment(item).locale("th").format("YYYY");
      var year2 = (parseInt(year1) + 543).toString();
      if (item) {
        return moment(item)
          .locale("th")
          .add(543, "year")
          .format("DD MMMM " + year2);
      } else {
        return "-";
      }
    },
    Datetime(item) {
      let datetime = new Date(
        new Date(item) - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, -1)
        .substr(0, 10);
      var [year, month, day] = datetime.split("-");
      return `${day}/${month}/${parseInt(year) + 543}`;
      // return moment(new Date(item)).format("DD/MM/YYYY");
    },
    convertType(item) {
      if (item.payments[item.payments.length - 1].paid) {
        const { payments } = item;
        const { detail } = payments[item.payments.length - 1];
        return detail.payment_type;
      }
    },
    paymentItem(item) {
      console.log("paymentItem", item);
      return ["1"];
    },
  },
};
</script>

<style scoped>
.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #fbfffe;
  border-radius: 80px 0px 0px 0px;
}

::v-deep .mx-input {
  border-radius: 20px 5px;
}

::v-deep .input.mx-input {
  background: #ceefed;
  border-radius: 20px 5px;
}
.table-viewdoc th {
  background: #ceefed !important;
  color: #00a99d !important;
}
#app {
  background-color: #eff6fc;
}
::v-deep .vue__time-picker > input.display-time {
  border: 1px solid #d2d2d2;
  width: 100%;
  /* height: 2.4em; */
  /* padding-right: 23px !important; */
  /* font-size: 1em; */
  border-radius: 4px;
}
.pr-6 {
  padding-right: 20px;
}
.container.fill-height {
  align-items: start;
}

.set-border-content {
  border-bottom: 1px solid #e5e5e5;
}

.set-badge {
  border: 1px solid #336ab4;
  border-radius: 4px;
  background: rgba(12, 117, 213, 0.05);
}

::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}

.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
  height: 32px;
}

.set-border-span {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  min-height: 32px;
  box-shadow: none;
  border: 1px solid #ebeef3;
}
.icon-card {
  /* margin-top: 8px; */
  /* margin-left: 42px; */
  width: 56px;
  height: 56px;
}

::v-deep .v-list-item--link:before {
  /* border-radius: 5px; */
  background-color: #00ad9f;
}

::v-deep .v-tabs-slider-wrapper {
  height: 5px !important;
  border-radius: 5px !important;
}

.card_pr {
  padding-right: 12px;
}

::v-deep .v-pagination__more {
  margin: 0.3rem;
  display: inline-flex;
  align-items: flex-end;
  justify-content: center;
  height: 32px;
  width: 16px;
  font-size: 10px !important;
}

::v-deep .v-pagination__navigation {
  background: #ffffff !important;
  color: #09425a;
  height: 25px !important;
  width: 20px !important;
  font-size: 10px !important;
}

::v-deep .v-pagination__item {
  min-width: 14px !important;
  font-size: 12px !important;
  height: 25px !important;
  width: 20px !important;
  padding: 0px !important;
}

::v-deep .v-pagination__item .v-pagination__item--active .primary {
  background-color: #23f250 !important;
  border-color: #f703ffe1 !important;
}

::v-deep .mx-input {
  height: 38px !important;
  border: 1px solid #ebeef3;
}

/* .theme-back-text {
  color: #ffffff;
  font-size: 18px;
  padding-left: 0px;
} */

/* .theme-light-text {
  color: #00a99d;
  font-size: 18px;
  padding-left: 0px;
} */

.card-medium {
  background: #ceefed !important;
  border-radius: 20px 5px !important;
  box-shadow: none !important;
}
.card-medium-cancel {
  border-radius: 20px 5px !important;
  box-shadow: none !important;
}

.icon-dark {
  background: #ceefed;
  border-radius: 16px 5px;
  padding: 5px;
}
.icon-light {
  background: #00a99d;
  border-radius: 16px 5px;
  padding: 5px;
}

::v-deep .v-image__image--cover {
  background-size: auto;
}

@media screen and (max-width: 960px) {
  .card_pr {
    padding-right: 0px;
  }
}

@media screen and (max-width: 600px) {
  .xs_font {
    /* visibility: hidden; */
    font-size: 15px;
  }
}
.mx-datepicker {
  width: 100%;
}
.v-btn-add {
  border-style: solid;
  border-color: linear-gradient(213.66deg, #16b4eb 4.85%, #23e73c 119.17%);
}
.theme-background {
  background-color: #00a99d !important;
  color: #ffffff !important;
}
.light-theme {
  background: #ceefed !important;
  color: #00a99d !important;
}
.v-list-item-group .v-list-item--active {
  color: #061b2e;
  background: #afeeee;
}
/* .icon-card {
  margin-top: 8px;
  margin-left: 22px;
  width: 24px;
  height: 24px;
} */
/* ::v-deep.v-autocomplete {
width: 189px!important;
height: 40px;
border-radius: 4px;
} */
::v-deep.v-input__slot {
  margin-right: 0px !important;
}
::v-deep.druglist {
  margin-left: 4.1%;
}

::v-deep .v-responsive {
  flex: none !important;
}

.card-small {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}

::v-deep .v-input input {
  line-height: 1.8rem;
  text-indent: 4px;
}
::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.8rem !important;
}
</style>
